var productFilters = new function () {
    this.doToggleFilters = function (event, el) {
        $('.product-list-columns__column').toggleClass('product-list-columns__column--mobile-open');
        $('body').toggleClass('filters-open');
    };
    this.doCloseFilters = function (event, el) {
        $('.product-list-columns__column').removeClass('product-list-columns__column--mobile-open');
        $('body').removeClass('filters-open');
    };
    this.doSelectedFilterCount = function () {
        var mobileFilterBtn = $('.product-top-filters__show-hide-filters'),
            selectedFiltersCount = $('.product-filters .wpc-custom-selected-terms .wpc-filter-chip:not(.wpc-chip-reset-all)').length,
            selectedFiltersCountEl = $('<span class="selected-filters-count" data-count="' + selectedFiltersCount + '">' + selectedFiltersCount + '</span>'),
            existingCount = mobileFilterBtn.find('.selected-filters-count').data('count');
        
        if (!$('.product-top-filters__show-hide-filters .selected-filters-count').length) {
            mobileFilterBtn.append(selectedFiltersCountEl);
        }
        if (existingCount !== selectedFiltersCount) {
            $('.product-top-filters__show-hide-filters .selected-filters-count').html(selectedFiltersCount).data('count', selectedFiltersCount).show();
        }
        
        if (!selectedFiltersCount) {
            $('.product-top-filters__show-hide-filters .selected-filters-count').hide();
        }
    }
    this.checkFilterAvailability = function() {
        var filterGroupCount = $('.wpc-filters-section').length,
            emptyfilterGroupCount = 0;
    
        $('.wpc-filters-section').map(function(i, item) {
            if($(item).find('.wpc-filters-ul-list').length && !$(item).find('.wpc-term-item').length) {
                $(item).hide();
                emptyfilterGroupCount++;
            }
        });
    
        if(filterGroupCount == emptyfilterGroupCount) {
            $('.product-filters').hide();
        } else {
            $('.product-filters').show();
        }

        // if($('body.tax-product_brand').length) {
        //     $('.product-list-columns__column--filters').hide();
        //     $('.product-list-columns__column--list').css('max-width', '100%');
        // }
    }
    // this.attachCloseFilterAttr = function() {
    //     $('.wpc-chip-reset-all a, .wpc-filters-ul-list li input').attr('data-click', 'productFilters:doCloseFilters');
    // }
    this.setFilterOptions = function() {
        $('.wpc-filters-section:not(.wpc-filter-terms-count-0)').map(function(i, item) {
            if($(item).find('.wpc-filter-selected-values').not(':empty')) {
                $(item).find('button span.wpc-wrap-icons').contents()
                    .filter(function(){
                        return this.nodeType !== 1;
                    })
                    .wrap("<span class='filter-attribute-title'></span>");
                var title = $.trim($(item).find('.filter-attribute-title').length ? $(item).find('.filter-attribute-title').text().toLowerCase() : $(item).find('.wpc-filter-title').text().toLowerCase());
    
                var defaultFilters = Object.values(defaultFilterOptions).filter(function(filter) {
                    return filter.title.toLowerCase() === title;
                });
    
                var additionalFilters = Object.values(additionalFilterOptions).filter(function(filter) {
                    return filter.title.toLowerCase() === title;
                });
                
                if (defaultFilters.length > 0) {
                    defaultFilters.forEach(function(matchedFilter) {
                
                        if (matchedFilter.open_on_load) {
                            $(item).removeClass('wpc-closed').addClass('wpc-opened');
                        } else {
                            $(item).removeClass('wpc-opened').addClass('wpc-closed');
                        }
            
                        if (matchedFilter.full_height) {
                            $(item).find('.wpc-filters-ul-list').css('max-height', 'unset');
                        }

                    });
                }
                
                if (additionalFilters.length > 0) {
                    additionalFilters.forEach(function(matchedFilter) {
                        var categoryCheck = matchedFilter.category === false || $('body').hasClass('term-' + matchedFilter.category);
                
                        if (categoryCheck) {

                            if (matchedFilter.open_on_load) {
                                $(item).removeClass('wpc-closed').addClass('wpc-opened');
                            } else {
                                $(item).removeClass('wpc-opened').addClass('wpc-closed');
                            }
                
                            if (matchedFilter.full_height) {
                                $(item).find('.wpc-filters-ul-list').css('max-height', 'unset');
                            } else {
                                $(item).find('.wpc-filters-ul-list').css('max-height', '');
                            }
                
                            if (matchedFilter.hidden) {
                                $(item).hide();
                            }
                        }
                    });
                }
                
            }
        });
    };
};

$(document).ready(function () {    
    productFilters.doSelectedFilterCount();
    // productFilters.attachCloseFilterAttr();
    productFilters.checkFilterAvailability();
    productFilters.setFilterOptions();

    // $(document).ajaxComplete(function (event, xhr, settings) {
    //     productFilters.doSelectedFilterCount(); 
    //     productFilters.checkFilterAvailability();
    //     // productFilters.attachCloseFilterAttr();
    //     productFilters.setFilterOptions();
    // });
});